module.exports = __webpack_public_path__ + "static/media/large-event-scaled.4cff31ea.jpeg";